jQuery(document).ready(function () {
    // jQuery(this).scrollTop(0);


    let background = jQuery('.background');

    jQuery('.background').css('opacity', 0)
    background[0].style.opacity = "1";
    setTimeout(function () {

        background.addClass('opacity');
    }, 1000);





});

jQuery(window).on('scroll', function () {
    //divided by the window height
    var windowHeight = window.innerHeight / 3
    // console.log(windowHeight);

    // Foreach items childrend
    jQuery('.items').children().each(function () {

        let offset = jQuery(this).offset().top - jQuery(window).scrollTop();
        if (offset < windowHeight && offset >= -jQuery(this).height()) {

            let top = jQuery(this).data('id');
            jQuery('.background').css('opacity', 0)
            let background = jQuery('.background');
            background[top - 1].style.opacity = "1";

        }

    });
})







